import domReady from '@wordpress/dom-ready';

const SESSION_KEY_PREFIX = 'utm_replacer_';
const WHATSAPP_LINK_SELECTOR = 'a[href*="wa.me"], a[href*="api.whatsapp.com"]';
const DATA_ELEMENT_ID = 'improntad-whatsapp-utm-replacer-data';

const readParamValue = (name, urlParams) => {
  const fromUrl = urlParams.get(name);
  if (fromUrl) {
    sessionStorage.setItem(SESSION_KEY_PREFIX + name, fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(SESSION_KEY_PREFIX + name);
};

const buildInterpolatedMessage = (template, values) => {
  let message = template;
  for (const [name, value] of Object.entries(values)) {
    const placeholder = `[${name.toUpperCase()}]`;
    message = message.split(placeholder).join(value);
  }
  return message;
};

const rewriteWhatsappLinks = (messageText) => {
  document.querySelectorAll(WHATSAPP_LINK_SELECTOR).forEach((link) => {
    const href = new URL(link.getAttribute('href'));
    href.searchParams.set('text', messageText);
    link.setAttribute('href', href);
  });
};

domReady(() => {
  const dataEl = document.getElementById(DATA_ELEMENT_ID);
  console.log('🚀 ~ dataEl:', dataEl);
  if (!dataEl) {return;}

  const paramNames = (dataEl.dataset.paramNames || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  console.log('🚀 ~ paramNames:', paramNames);
  const baseText = dataEl.dataset.baseText || '';
  const interpolatedText = dataEl.dataset.interpolatedText || '';

  const urlParams = new URLSearchParams(window.location.search);
  console.log('🚀 ~ urlParams:', urlParams);
  const values = {};
  let allPresent = paramNames.length > 0;
  
  for (const name of paramNames) {
    const value = readParamValue(name, urlParams);
    if (!value) {
      allPresent = false;
      break;
    }
    values[name] = value.replace(/-/g, ' ');
  }
  
  console.log('🚀 ~ allPresent:', allPresent);
  const messageText =
    allPresent && interpolatedText
      ? buildInterpolatedMessage(interpolatedText, values)
      : baseText;
  console.log('🚀 ~ messageText:', messageText);

  if (!messageText) {return;}

  rewriteWhatsappLinks(messageText);
});
